"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var background_native_exports = {};
__export(background_native_exports, {
  createLatestComputation: () => import_createLatestComputation.createLatestComputation,
  defineBackgroundComputation: () => defineBackgroundComputation,
  useBackgroundComputation: () => import_useBackgroundComputation.useBackgroundComputation
});
module.exports = __toCommonJS(background_native_exports);
var import_executor = require("./background/executor.native");
var import_createLatestComputation = require("./background/createLatestComputation");
var import_useBackgroundComputation = require("./background/useBackgroundComputation");
function defineBackgroundComputation(calculate) {
  return Object.freeze({
    createExecutor: function createExecutor() {
      return (0, import_executor.createWorkletExecutor)(calculate);
    }
  });
}
//# sourceMappingURL=background.native.js.map
